import React from 'react';
import './ContactPage.css';

const TOPICS = [
  { label: 'Üyelik başvurusu ve koşulları', href: 'mailto:info@tkmb.org?subject=Üyelik%20başvurusu' },
  { label: 'Mesleki standartlar ve rehberler', href: 'mailto:info@tkmb.org?subject=Mesleki%20standartlar' },
  { label: 'Sanayi iş birlikleri ve eğitim talepleri', href: 'mailto:info@tkmb.org?subject=Sanayi%20iş%20birliği' },
  { label: 'Genel bilgi ve iş birliği önerileri', href: 'mailto:info@tkmb.org?subject=Genel%20bilgi' },
];

const ContactPage = () => {
  return (
    <div className="contact-page">
      <div className="page-hero">
        <div className="container">
          <h1 className="page-hero-title">İletişim</h1>
          <p className="page-hero-subtitle">
            TKMB – Türkiye Kalite Mühendisleri Birliği ile iletişime geçmek için aşağıdaki bilgileri kullanabilirsiniz.
          </p>
        </div>
      </div>

      <div className="contact-page-content">
        <div className="container">
          <section className="contact-intro">
            <p>
              Üyelik, mesleki standartlar, sanayi iş birlikleri veya genel sorularınız için e-posta ile bize
              ulaşabilirsiniz. Konu başlığını belirtmeniz yanıt sürecini hızlandırır.
            </p>
          </section>

          <div className="contact-info contact-info-tkmb">
            <div className="info-item info-item-main">
              <h3>Kurum</h3>
              <p className="org-name">Türkiye Kalite Mühendisleri Derneği</p>
              <p className="org-sub">TKMB – Türkiye Kalite Mühendisleri Birliği</p>
            </div>
            <div className="info-item">
              <h3>Web sitesi</h3>
              <a href="https://www.tkmb.org" target="_blank" rel="noopener noreferrer">www.tkmb.org</a>
            </div>
            <div className="info-item">
              <h3>E-posta</h3>
              <a href="mailto:info@tkmb.org">info@tkmb.org</a>
              <p className="info-note">Genel soru ve başvurular için</p>
            </div>
            <div className="info-item">
              <h3>Telefon</h3>
              <a href="tel:+905346659292" className="contact-phone">0534 665 92 92</a>
              <p className="info-note">Arama ve WhatsApp</p>
            </div>
            <div className="info-item">
              <h3>WhatsApp</h3>
              <a href="https://wa.me/905346659292" target="_blank" rel="noopener noreferrer">0534 665 92 92</a>
              <p className="info-note">Hızlı iletişim için</p>
            </div>
          </div>

          <section className="contact-topics">
            <h2>Hızlı yönlendirme</h2>
            <p className="topics-lead">
              Aşağıdaki konulardan birini seçerek doğrudan ilgili konu başlığı ile e-posta gönderebilirsiniz:
            </p>
            <ul className="topic-links">
              {TOPICS.map((item, index) => (
                <li key={index}>
                  <a href={item.href}>{item.label}</a>
                </li>
              ))}
            </ul>
          </section>

          <div className="contact-note">
            <p>
              E-posta mesajlarınıza mümkün olan en kısa sürede yanıt verilmeye çalışılmaktadır. Yoğun dönemlerde
              yanıt süresi uzayabilir; acil konularda konu başlığında belirtmeniz faydalı olur.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
